export const alphaFromHex = (hex, alpha) => {
    if (!hex) return `rgba(0,0,0,${alpha})`;

    if (typeof hex === "string") {
        if (hex.includes("--kbs-primary")) {
            return `rgba(var(--kbs-primary-rgb, 0,173,255), ${alpha})`;
        }
        if (hex.includes("--kbs-secondary")) {
            return `rgba(var(--kbs-secondary-rgb, 0,108,168), ${alpha})`;
        }
        if (hex.includes("--kbs-text-on-primary")) {
            return `rgba(var(--kbs-text-on-primary-rgb, 20,21,26), ${alpha})`;
        }
    }

    let c = hex.replace("#", "");
    if (c.length === 3) {
        c = c
            .split("")
            .map((ch) => ch + ch)
            .join("");
    }
    const r = parseInt(c.slice(0, 2), 16) || 0;
    const g = parseInt(c.slice(2, 4), 16) || 0;
    const b = parseInt(c.slice(4, 6), 16) || 0;
    return `rgba(${r},${g},${b},${alpha})`;
};
